export interface NO05SearchParams {
  companyId: string;
  status?: string;
  orderNumber?: string;
  customerNumber?: string;
  requisitionNumber?: string;
  productId?: string;
  invoiceCreditNumber?: string;
  receiver?: string;
  location?: string;
  address?: string;
  department?: string;
  warehouse?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
  skipPaging?: boolean;
}

export interface NO05StatusStat {
  status: string;
  count: number;
  totalAmount: number;
  brfProsent: number;
  antBestilt: number;
  antLevert: number;
}

export interface NO05Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;
  speditor: string;
  direkteFlagg: string;
  skaff: string;
  bk: string;
}

export default class NO05 implements NO05Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;
  speditor: string;
  direkteFlagg: string;
  skaff: string;
  bk: string;

  constructor(
    ordreNr = '', kundenr = '', navn = '', rekvNr = '',
    dato = '', tid = '', om = '', status = '',
    antBestilt = 0, antLevert = 0, belop = 0, brfProsent = 0,
    faktura = '', fraktEdi = '', ordreType = '', betalingsKode = '', sendeMote = '',
    speditor = '', direkteFlagg = '', skaff = '', bk = '',
  ) {
    this.ordreNr = ordreNr; this.kundenr = kundenr; this.navn = navn;
    this.rekvNr = rekvNr; this.dato = dato; this.tid = tid; this.om = om;
    this.status = status; this.antBestilt = antBestilt; this.antLevert = antLevert;
    this.belop = belop; this.brfProsent = brfProsent; this.faktura = faktura;
    this.fraktEdi = fraktEdi; this.ordreType = ordreType;
    this.betalingsKode = betalingsKode; this.sendeMote = sendeMote;
    this.speditor = speditor; this.direkteFlagg = direkteFlagg;
    this.skaff = skaff; this.bk = bk;
  }
}
